
export default {
  props: {
    classes: String,
    style: Object,
    icon: String,
  },
}
